<template>
  <v-content>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="titulos">Recursos</h1>
          <v-layout row wrap>
            <v-flex xs12 md3>
              <v-menu
                :close-on-content-click="false"
                v-model="searchDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px">
                <v-text-field
                  slot="activator"
                  v-model="dateFormatted"
                  label="Fecha disponibilidad"
                  hint="YYYY-MM-DD"
                  persistent-hint
                  prepend-icon="event"
                  @blur="date = parseDate(dateFormatted)"></v-text-field>
                <v-date-picker v-model="date" no-title @input="searchDate = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md3>
              <v-select
                v-model="selectedHours"
                :items="hours"
                item-value="id"
                clearable
                label="Hora disponibilidad">
                  <template slot="selection" slot-scope="data">
                    {{ data.item.start_time }} - {{ data.item.end_time }}
                  </template>
                  <template slot="item" slot-scope="data">
                    {{ data.item.start_time }} - {{ data.item.end_time }}
                  </template>
              </v-select>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                prepend-icon="search"
                label="Buscar"
                hide-details
                v-model="search"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-select
                :items="resource_types"
                v-model="resource_type"
                item-text="name"
                item-value="name"
                label="Tipo de recurso"
                prepend-icon="list"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headers"
            hide-actions
            :search="{search: search, dataFormatted:dateFormatted, selectedHours: selectedHours}"
            :items="filteredItems"
            :pagination.sync="pagination"
            :custom-filter="customFilter"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn depressed @click="reservar(props.item.id, props.item.name)">
                  <v-icon>date_range</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.ResourceType.name }}</td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Tu busqueda "{{ search || dateFormatted}}" no ha encontrado resultados.
            </v-alert>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </div>
          <v-snackbar
            :timeout=6000
            :color="color"
            :multi-line="'multi-line'"
            v-model="snackbar">
            <v-icon dark>error_outline</v-icon>
            {{ error }}
            <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable */
  import Shared from '@/services/Shared';
  import moment from 'moment';
  import _ from 'lodash';

  export default {
    data() {
      //:items="items"
      return {
        items: [],
        hours: [],
        selectedHours: null,
        resource_types: [],
        resource_type: '',
        headers: [
          {text: 'Reservar', value: 'reservar', width: '100'},
          {text: 'Recurso', value: 'name'},
          {text: 'Tipo', value: 'resource_type'}
        ],
        pagination: {
          rowsPerPage: 10
        },
        error: null,
        snackbar: false,
        color: '',
        search: '',
        date: null,
        dateFormatted: null,
        searchDate: false
      }
    },
    created() {
      this.resources()
      this.types()
    },
    methods: {
      async resources() {
        try {
          const response = await Shared.resources()
          this.items = response.data.data
          this.hours = response.data.hours
          //console.log(this.items)
        } catch (err) {
          console.log(err)
        }
      },
      async types() {
        try {
          const response = await Shared.resourcesTypes()
          this.resource_types = response.data.data
        } catch (err) {
          console.log(err)
        }
      },
      navigateTo(route) {
        this.$router.push(route)
      },
      reservar(id, name) {
        this.$router.push({name: "reservation", params: {id, name}})
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${year}-${month}-${day}`
      },
      parseDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      customFilter(items, search, filter) {
        if (!search.dataFormatted && !search.search && !search.selectedHours) { return items }

        //console.log(search)

        if (moment(search.dataFormatted, 'YYYY-MM-DD', true).isValid() || typeof search.selectedHours === 'number') {

          const reservas = _.filter(items, function(element) {
            var isMatch = false;
            _.forEach(element.Reservations, function(entry) {
              //console.log(search)
              if (entry.date === search.dataFormatted && entry.hour_id === search.selectedHours) {
                isMatch = true;
                return false; // this just exits the forEach loop
              }
            });
            return isMatch;
          });

          return _.filter(items, (v) => _.findIndex(reservas, {'id': v.id}) === -1)

        } else {
          function  new_filter (val, search) {
            return val !== null &&
              ['undefined', 'boolean'].indexOf(typeof val) === -1 &&
              val.toString().toLowerCase().replace(/[^0-9a-zA-Z]+/g,"").indexOf(search) !== -1
          }
          let needleAry = search['search'].toString().toLowerCase().split(" ").filter(x => x);
          return items.filter(row => needleAry.every(needle => Object.keys(row).some(key => new_filter(row[key],needle))));
        }

      }
    },
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      }
    },
    computed: {
      pages() {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      },
      filteredItems() {
        return this.items.filter((i) => {
          return !this.resource_type || (i.ResourceType.name === this.resource_type);
        })
      }
    },
  };
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue